import{jsx as e}from"react/jsx-runtime";import{Container as n}from"./LoadingElement.styles.js";const o=({width:t="100px",height:i="20px",variant:r="rectangle"})=>e(n,{width:t,height:i,variant:r});export{o as LoadingElement};
